module.exports = __webpack_public_path__ + "img/entry-button.141ef602.png";